import React, {useContext, useState} from 'react';
import BuildingSummary from "../building/buildingSummary";
import AccountManagement from "../accountManagement/accountManagement";
import TeachingSummary from "../teachingSummary/teachingSummary";
import Footer from "../../components/footer";
import Loader from "../../components/loader";
import ToSModal from "../../components/tosModal";
import userContext from "../../context/userContext";
import {useNavigate} from "react-router-dom";

function Administration() {
    const [currentPage, setCurrentPage] = useState('learning')
    const user = useContext(userContext)
    const navigate = useNavigate()

    if (!user.userContext) {
        return <Loader message={'Fetching user data'}/>
    } else if (!user.userContext.termsAccepted) {
        return <ToSModal user={user}/>
    } else if (user.userContext.role === 'student') {
        navigate('/home')
    } else {
        return (
            <>
                <div className={'mb-2'}>
                    <div className={'flex gap-2 mx-1'}>
                        {(currentPage !== 'learning') ?
                            <button
                                className={'bg-columbia_blue-300 text-dutch_white-900 rounded-t text-xl font-bold p-4 hover:bg-columbia_blue-400 cursor-pointer unselected-tab'}
                                onClick={() => setCurrentPage('learning')}>Learning Overview</button>
                            : <div
                                className={'bg-columbia_blue-900 text-dutch_white-200 text-xl font-bold p-4 rounded-t select-none'}>Learning
                                Overview</div>
                        }
                        {(currentPage !== 'teaching') ?
                            <button
                                className={'bg-burnt_sienna-200 text-dutch_white-900 rounded-t text-xl font-bold p-4 hover:bg-burnt_sienna-300 cursor-pointer unselected-tab'}
                                onClick={() => setCurrentPage('teaching')}>Teaching Overview</button>
                            : <div
                                className={'bg-burnt_sienna-700 text-dutch_white-200 text-xl font-bold p-4 rounded-t select-none'}>Teaching
                                Overview</div>
                        }
                        {(currentPage !== 'accounts') ?
                            <button
                                className={'bg-columbia_blue-300 text-dutch_white-900 rounded-t text-xl font-bold p-4 hover:bg-columbia_blue-400 cursor-pointer unselected-tab'}
                                onClick={() => setCurrentPage('accounts')}>Account Management</button>
                            : <div
                                className={'bg-dutch_white-100 text-dutch_white-900 text-xl font-bold p-4 rounded-t select-none'}>Account
                                Management</div>}
                    </div>
                    {(currentPage === 'learning') && <BuildingSummary/>}
                    {(currentPage === 'teaching') && <TeachingSummary/>}
                    {(currentPage === 'accounts') && <AccountManagement/>}

                </div>
                <Footer/>
            </>
        );
    }
}

export default Administration;